<template>
  <form
    class="grid grid-cols-4 gap-4 overflow-hidden rounded-lg p-2"
    @submit="onSubmit"
  >
    <FormInputCheckbox
      name="isVatEnabled"
      label="Vat Enabled"
      class="col-span-4"
    />
    <FormInputText
      name="vatNumber"
      label="VAT number"
      :disabled="!values.isVatEnabled"
      class="col-span-4"
    />

    <FormInputDefaultVatRate
      name="defaultVatRate"
      label="Default VAT Rate"
      :disabled="!values.isVatEnabled"
      class="col-span-4"
      hint="This option enables a default VAT rate to be applied
      automatically for all non-product sales/items. If you
      do not have products enabled, this default VAT rate
      will apply to all sales processed automatically. If
      you have products enabled, this will only apply where
      you use the “Add item” feature on the till – otherwise
      the product will use the VAT rate you configured on
      that product"
    />
    <div class="col-span-4 flex justify-end">
      <FormSubmitButton> Save </FormSubmitButton>
    </div>
    <template v-if="isSubmitting">
      <div class="bg-background-fg/8 absolute inset-0">
      </div>
    </template>
  </form>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const { vatSettings, setTenantState } = useTenant()
const vatFormSchema = z.object({
  isVatEnabled: z.boolean(),
  vatNumber: z.string(),
  defaultVatRate: z.number().min(0).nullable(),
})

const { handleSubmit, values, setValues } = useForm({
  validationSchema: toTypedSchema(vatFormSchema),
  initialValues: {
    isVatEnabled: false,
    vatNumber: "",
    defaultVatRate: 0,
  },
})

watch(
  () => vatSettings.value,
  (value) => {
    setValues(value)
  },
  { deep: true, immediate: true }
)

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (params) => {
  isSubmitting.value = true
  try {
    const newVatSettings =
      await partialUpdateSettings(params)
    setTenantState(newVatSettings)
    toast.success("VAT settings updated")
  } catch (error) {
    toast.error("Failed to update VAT settings")
    throw error
  } finally {
    isSubmitting.value = false
  }
})
</script>
